import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderBluePay } from '../../providers/payment/payment.bluepay'

/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */
export const regionValues = {
  region: Region.CA,
  regionId: 605,
  defaultCountryFrom: 'CA',
  defaultCountryFromOnfido: 'CAN',
  defaultCountryCodeFrom: 1,
  defaultCurrencyFrom: 'CAD',
  defaultAmountFrom: 100,
  defaultLanguageCulture: 'en-CA',
  defaultLocation: {
    latitude: 45.4215,
    longitude: -75.6972
  },
  dateFormat: 'YYYY/MM/DD',    
  /**
   * @summary
   * Postal code Canada reference (changed to allow lowercase as well)
   * https://en.wikipedia.org/wiki/Postal_codes_in_Canada
   * https://howtodoinjava.com/regex/canada-postal-code-validation/
   */  
  postalCodeRegex:`^[A-Za-z]\\d[A-Za-z](\\s\\d[A-Za-z]\\d)?$`,
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['en-CA', 'fr-CA', 'vi-CA'],
  regionalIp: '192.197.183.241',
  paymentProvider: <IPaymentProvider>new PaymentProviderBluePay(),
  isPlaidEnabled: true,
  isBankAccountEnabled:true,
  useSecurityQuestions: true,
  oldRemittanceLogin: true,
  onfidoMaxAttempts: 0,
  directBankBrand:'',
  distanceMetric: 'km',
  acceptInternationalCards:false,
  stagedRiaBrand: '',
  payNearMeBrand: '',
  isEu: false,
  isEMEA: false,
  notShowMarketingPushAlert: true,
  useVeriff: false,
  googlepayAdyenPaymentNetworks: ["masterCard", "visa", "interac"],
  applepayAdyenPaymentNetworks: ["masterCard", "visa", "interac"],
  adyenMerchantCapability: ["debit", "3ds", "credit"],
  walletSettings:{
    isMerchantSupportEnable:false,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: false,
  canShowLogosOnQRScanner: false,
  airtimeServices:{
    isAirTimeSevice:false,
    isLocalOnly:false,
  },
  passCodeLength: 6,
  showNewHomePage: true,
  walletServices:[],
  isCountrySupportDecimal: true,
  autoEnableMarketingPreference: true,
  loginRootHomePage: "activity",
  adyenRegion: 'live-us'// https://docs.adyen.com/development-resources/live-endpoints/#client-side-environment-region
};



// WEBPACK FOOTER //
// ./src/environment/region/CA.ts